import { gql } from '@apollo/client'

const REVIEW_PLAN_CHANGES_FRAGMENT = gql`
  fragment ReviewPlanChangesFragment on Plan {
    id
    durationInWeeks
    numberOfPouches
    pricePerDay
    pouchesPerDay
    pouchSize
    servingInformation {
      roundedCaloriesPerDay
      gramsPerDay
    }
  }
`

export { REVIEW_PLAN_CHANGES_FRAGMENT }
